import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

export const infoStrip = css`
  display: flex;
  align-items: stretch;
  margin: 0;
  padding: 0;
  list-style: none;
  border-top: 1px solid color-mix(in srgb, var(${colors.stroke.default}) 20%, transparent);
`;

export const infoItem = css`
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: calc(var(${spacing.xxs}) / 2);
  text-align: center;
  color: var(${colors.content.secondary});
  font-size: var(${typography.body.sizes.sm.fontSize});

  &:not(:first-of-type) {
    border-left: 1px solid var(${colors.stroke.default});
  }
`;

export const infoItemValue = css`
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
  color: var(${colors.content.default});
`;
